// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resident-detail-tab[data-v-2ca47e4e]{position:relative;width:100%;min-height:240px}.resident-detail-tab .resident-detail-content[data-v-2ca47e4e]{max-width:800px;min-width:640px}.resident-detail-tab .buttons[data-v-2ca47e4e]{width:325px}.resident-detail-tab .buttons .edit-btn[data-v-2ca47e4e]{width:110px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
